/**
 * @desc 取消退货单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.RejectBillOperationDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/asMasterialReject/rejectBillCancel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
